import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Cpu, Zap, Activity, Radio, Cable } from 'lucide-react';

const Products = () => {
  const semiconductors = [
    'Microcontrollers',
    'Microprocessors',
    'Memory ICs (RAM, ROM, Flash)',
    'Power Management ICs (PMIC)',
    'Analog ICs',
    'Logic ICs',
    'RF & Wireless ICs',
    'Digital Signal Processors (DSP)',
    'Application Specific ICs (ASIC)'
  ];

  const discreteComponents = [
    'Diodes (Rectifier, Zener, Schottky)',
    'Transistors (BJT, FET)',
    'MOSFETs (Power MOSFETs)',
    'IGBTs (Insulated Gate Bipolar Transistors)',
    'Thyristors (SCR, TRIAC)',
    'Bridge Rectifiers',
    'Varistors'
  ];

  const passiveComponents = [
    'Resistors (Fixed, Variable, SMD)',
    'Capacitors (Ceramic, Electrolytic, Tantalum, Film)',
    'Inductors (Power, RF, SMD)',
    'Transformers',
    'Ferrite Beads',
    'Potentiometers',
    'Thermistors'
  ];

  const activeComponents = [
    'Sensors (Temperature, Pressure, Proximity)',
    'Relays (Electromechanical, Solid State)',
    'Optocouplers',
    'LED Drivers',
    'Display Modules',
    'Crystal Oscillators',
    'Power Modules',
    'Voltage Regulators'
  ];

  const electromechanicalComponents = [
    'Connectors (Board-to-Board, Wire-to-Board, PCB)',
    'Switches (Push Button, Toggle, DIP, Rocker)',
    'Relays (Power Relays, Signal Relays)',
    'Terminal Blocks',
    'Fuses and Circuit Breakers',
    'Sockets and Headers',
    'Cable Assemblies',
    'Cooling Fans and Heat Sinks',
    'Enclosures and Hardware'
  ];

  const categories = [
    {
      icon: Cpu,
      title: 'Semiconductors (ICs)',
      color: 'blue',
      items: semiconductors
    },
    {
      icon: Zap,
      title: 'Discrete Components',
      color: 'orange',
      items: discreteComponents
    },
    {
      icon: Activity,
      title: 'Passive Components',
      color: 'green',
      items: passiveComponents
    },
    {
      icon: Radio,
      title: 'Active Components',
      color: 'purple',
      items: activeComponents
    },
    {
      icon: Cable,
      title: 'Electromechanical Components',
      color: 'indigo',
      items: electromechanicalComponents
    }
  ];

  return (
    <div className="products-page">
      <div className="page-header">
        <div className="container mx-auto px-6 py-16">
          <h1 className="page-title">Our Products</h1>
          <p className="page-subtitle">
            Comprehensive range of electronic components for all your manufacturing needs
          </p>
        </div>
      </div>

      <div className="container mx-auto px-6 py-12">
        <div className="space-y-12">
          {categories.map((category, index) => {
            const IconComponent = category.icon;
            return (
              <Card key={index} className="product-category-card">
                <CardHeader>
                  <div className="flex items-center gap-4">
                    <div className={`category-icon-${category.color}`}>
                      <IconComponent className="h-8 w-8" />
                    </div>
                    <CardTitle className="text-2xl">{category.title}</CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {category.items.map((item, idx) => (
                      <div key={idx} className="product-item">
                        <div className="product-bullet"></div>
                        <span className="product-name">{item}</span>
                      </div>
                    ))}
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="mt-16 text-center">
          <div className="product-note">
            <p className="text-lg font-medium mb-2">Can't find what you're looking for?</p>
            <p className="text-gray-600">
              We source components from a vast network of suppliers. Contact us with your requirements.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Products;
